/**
 * trabaja-con-nosotros.js  —  v3
 * Quiero Natural · Uruguay
 */

(function () {
  'use strict';

  const cfg = window.jobsConfig || {};

  const $ = (id) => document.getElementById(id);

  let cvBase64 = '';
  let cvNombre = '';

  /* ── Cargar EmailJS lazy ── */
  function loadEmailJS(cb) {
    if (window.emailjs) { cb(); return; }
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
    s.onload = () => { emailjs.init({ publicKey: cfg.publicKey }); cb(); };
    s.onerror = () => mostrarMsg(cfg.msgError || 'Error de conexión. Intentá de nuevo.', 'error');
    document.head.appendChild(s);
  }

  /* ── Manejo de archivo ── */
  function handleFile(input) {
    const file = input.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      mostrarMsg('El archivo supera los 5 MB. Por favor subí uno más liviano.', 'error');
      input.value = ''; return;
    }

    const ext = '.' + file.name.split('.').pop().toLowerCase();
    if (!['.pdf', '.doc', '.docx'].includes(ext)) {
      mostrarMsg('Formato no permitido. Subí un PDF, DOC o DOCX.', 'error');
      input.value = ''; return;
    }

    cvNombre = file.name;
    const el = $('jn-filename');
    el.textContent = '📎 ' + file.name;
    el.classList.add('visible');

    const reader = new FileReader();
    reader.onload = (e) => { cvBase64 = e.target.result; };
    reader.readAsDataURL(file);
  }

  /* ── Drag & drop ── */
  function initDragDrop() {
    const zone = $('jn-dropzone');
    if (!zone) return;
    zone.addEventListener('dragover',  (e) => { e.preventDefault(); zone.classList.add('dragover'); });
    zone.addEventListener('dragleave', ()  => zone.classList.remove('dragover'));
    zone.addEventListener('drop', (e) => {
      e.preventDefault();
      zone.classList.remove('dragover');
      const file = e.dataTransfer.files[0];
      if (!file) return;
      try {
        const dt = new DataTransfer();
        dt.items.add(file);
        const input = $('jn-cv');
        input.files = dt.files;
        handleFile(input);
      } catch (_) {}
    });
  }

  /* ── Formato teléfono UY ── */
  function initTelFormat() {
    const tel = $('jn-telefono');
    if (!tel) return;
    tel.addEventListener('input', () => {
      let v = tel.value.replace(/\D/g, '');
      if (v.startsWith('09') && v.length > 3) {
        v = v.slice(0, 3) + ' ' + v.slice(3, 6) + (v.length > 6 ? ' ' + v.slice(6, 9) : '');
      } else if (!v.startsWith('0') && v.length > 4) {
        v = v.slice(0, 4) + ' ' + v.slice(4, 8);
      }
      tel.value = v;
    });
  }

  /* ── Validación ── */
  function validar() {
    if (!$('jn-nombre')?.value.trim())   { mostrarMsg('Por favor ingresá tu nombre.', 'error'); return false; }
    if (!$('jn-apellido')?.value.trim()) { mostrarMsg('Por favor ingresá tu apellido.', 'error'); return false; }
    const email = $('jn-email')?.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { mostrarMsg('Por favor ingresá un email válido.', 'error'); return false; }
    if (!$('jn-puesto')?.value) { mostrarMsg('Seleccioná el área a la que te postulás.', 'error'); return false; }
    if (!cvBase64) { mostrarMsg('Por favor adjuntá tu CV antes de enviar.', 'error'); return false; }
    return true;
  }

  /* ── Envío ── */
  function enviar() {
    ocultarMsg();
    if (!validar()) return;

    if (!cfg.publicKey || !cfg.serviceId || !cfg.templateId ||
        cfg.publicKey === 'null' || cfg.serviceId === 'null' || cfg.templateId === 'null') {
      mostrarMsg('La sección no está configurada. Completá las claves de EmailJS en el editor de Shopify.', 'error');
      return;
    }

    const btn = $('jn-submit');
    btn.disabled = true;
    btn.classList.add('is-loading');

    const nombre   = $('jn-nombre').value.trim();
    const apellido = $('jn-apellido').value.trim();
    const telefono = $('jn-telefono').value.trim();

    const params = {
      nombre_completo: nombre + ' ' + apellido,
      nombre, apellido,
      email:     $('jn-email').value.trim(),
      telefono:  telefono ? '+598 ' + telefono : 'No indicado',
      puesto:    $('jn-puesto').value,
      mensaje:   $('jn-mensaje').value.trim() || 'Sin mensaje',
      cv_nombre: cvNombre,
      cv_base64: cvBase64,
    };

    loadEmailJS(() => {
      emailjs.send(cfg.serviceId, cfg.templateId, params)
        .then(() => {
          const msgOk = (cfg.msgExito || '¡Gracias! Recibimos tu postulación 🌿')
            .replace('{{nombre}}', nombre);
          mostrarMsg(msgOk, 'success');
          limpiar();
        })
        .catch((err) => {
          console.error('[Jobs] EmailJS:', err);
          mostrarMsg(cfg.msgError || 'Hubo un error al enviar. Intentá de nuevo.', 'error');
        })
        .finally(() => {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    });
  }

  /* ── Limpiar ── */
  function limpiar() {
    ['jn-nombre','jn-apellido','jn-email','jn-telefono','jn-mensaje'].forEach(id => {
      const el = $(id); if (el) el.value = '';
    });
    const sel = $('jn-puesto'); if (sel) sel.selectedIndex = 0;
    const cv  = $('jn-cv');    if (cv)  cv.value = '';
    const fn  = $('jn-filename');
    if (fn) { fn.textContent = ''; fn.classList.remove('visible'); }
    cvBase64 = ''; cvNombre = '';
  }

  function mostrarMsg(txt, tipo) {
    const el = $('jn-msg'); if (!el) return;
    el.textContent = txt;
    el.className = 'jobs-msg is-' + tipo;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function ocultarMsg() {
    const el = $('jn-msg'); if (el) el.className = 'jobs-msg';
  }

  /* ── Init ── */
  function init() {
    const cvInput = $('jn-cv');
    if (cvInput) cvInput.addEventListener('change', () => handleFile(cvInput));
    const btn = $('jn-submit');
    if (btn) btn.addEventListener('click', enviar);
    initDragDrop();
    initTelFormat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();